import * as z from 'zod';

// Schema for assigned team member
const assignedToSchema = z.object({
  name: z.string(),
  phoneNumber: z.string(),
});

export const databaseUploadSchema = z
  .object({
    aiOptedIn: z.enum(['yes', 'no'], {
      required_error: 'Please select if contacts have opted in for AI calls',
    }),
    flowTypes: z
      .array(z.enum(['engage', 'revive', 'e-alerts']))
      .optional()
      .nullable(),
    tags: z.array(z.string()).optional(),
    assignedTo: assignedToSchema.optional().nullable(),
    acknowledgeOptIn: z.boolean().optional(),
    // Agent assignment filter fields (like Convert integrations)
    useAssignment: z.boolean().optional(),
    assignmentAction: z.enum(['assign', 'unassigned', '']).optional(),
    assignedAgents: z.array(z.string()).optional(),
    // Additional notes for the upload
    additionalNotes: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    // If opted in, at least one flow type is required
    if (data.aiOptedIn === 'yes' && (!data.flowTypes || data.flowTypes.length === 0)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'At least one flow type is required when contacts have opted in',
        path: ['flowTypes'],
      });
    }

    // If opted in, acknowledgment is required
    if (data.aiOptedIn === 'yes' && !data.acknowledgeOptIn) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'You must acknowledge the opt-in agreement',
        path: ['acknowledgeOptIn'],
      });
    }
  });

export type DatabaseUploadFormData = z.infer<typeof databaseUploadSchema>;
